import { Component, HostListener } from '@angular/core';

/**
 * Fixed, always-visible contact CTA. A single trigger ("Need help? Schedule a
 * call or email us") that opens a chooser to schedule a call (Calendly, new tab)
 * or email us (with a copy-address option). Reused across pages — drop it inside
 * an <ion-content> with slot="fixed" so it stays pinned while the page scrolls:
 *
 *   <app-help-widget slot="fixed" style="bottom:20px;right:20px;z-index:50"></app-help-widget>
 *
 * Navigation is done programmatically (not via <a>) so closing the menu — which
 * removes the element via *ngIf — can never cancel the browser's default action.
 */
@Component({
  selector: 'app-help-widget',
  templateUrl: './help-widget.component.html',
  styleUrls: ['./help-widget.component.scss'],
})
export class HelpWidgetComponent {
  readonly bookingUrl = 'https://calendly.com/totalum/30min';
  readonly contactEmail = 'contact@totalum.app';
  readonly contactMailto = 'mailto:contact@totalum.app?subject=I%20need%20help%20with%20the%20Totalum%20API';
  helpMenuOpen = false;
  emailCopied = false;

  @HostListener('document:click', ['$event'])
  onDocClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (this.helpMenuOpen && !target.closest('.vcaas-help-widget')) {
      this.helpMenuOpen = false;
    }
  }

  scheduleCall(): void {
    window.open(this.bookingUrl, '_blank', 'noopener');
    this.helpMenuOpen = false;
  }

  emailUs(): void {
    window.location.href = this.contactMailto;
    this.helpMenuOpen = false;
  }

  async copyEmail(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.contactEmail);
      this.emailCopied = true;
      setTimeout(() => (this.emailCopied = false), 2000);
    } catch (e) {
      console.error('Copy failed', e);
    }
  }
}
